import * as Routes from '../../scripts/routes';
import { notification } from 'antd';
import _isEmpty from 'lodash/isEmpty';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  AberturaProcessoController = ($http, $scope, $timeout, $window) ->
    vm = @

    # CONSTANTS


    # VARIABLES VIEW MODEL
    vm.form                = {
      tipo_id:      null,
      assunto_id:   null,
      movimentacao: {destino_orgao_id: null}
    }
    vm.assuntos            = []
    vm.orgaos              = []
    vm.allOrgaos           = []
    vm.protocolos          = []
    vm.loadingAssuntos     = false
    vm.showOverlayPassos   = true
    vm.workflow_documentos = {}
    vm.baseUploadProps     = {}
    vm.uploadProps         = {}
    vm.abrirWorkFlow       = true
    vm.possuiFluxo         = true
    vm.setarSetor          = {}
    vm.uploadDocumentos    = false
    vm.destino_setor_carregado = null
    vm.buscaAssuntos       = null
    vm.formularioPersonalizado = null
    vm.camposPersonalizados    = {}
    vm.formularioPersonalizadoValores = {}
    vm.formularioPersonalizadoErros = []
    vm._longTextEditorsReady   = false
    vm.workflowSetorInativo = false

    # VARIAVEIS PRIVATE
    corpoPresent = false

    # WATCHES

    # WATCH PROCESSO WORKFLOW
    $scope.$watchCollection (->
      [parseInt(vm.form.tipo_id), parseInt(vm.form.assunto_id?.id), parseInt(vm.form.movimentacao.destino_orgao_id?.id)]
    ), (current, original) ->
      if current[0] && current[1] && current[2]
        checarDocumentosWorkflow({
          orgao_id:   current[2],
          tipo_id:    current[0],
          assunto_id: current[1]
        }).then ->
          carregarProtocolos()
      else
        resetWorkflowSetorInativo()

    # CHANGE SELECT TIPO PROCESSO
    $scope.$watch (->
      vm.form.tipo_id
    ), (current, _original) ->
      if current?
        id = current
        id = current.id if current?.id?
        setAssuntos(id)
      else
        vm.form.tipo_id    = null
        vm.form.assunto_id = null

      return

    # CHANGE BASE UPLOAD PROPS
    $scope.$watch (->
      vm.baseUploadProps
    ), (current, _original) ->
      vm.uploadProps = current if current?
      return

    # WATCH BLOCKED ORGAO BY ASSUNTO PROCESSO
    $scope.$watch (->
      vm.form.assunto_id
    ), (current, _original) ->
      if current?
        id = current
        id = current.id if current?.id?
        blockedOrgaosByAssuntoId(id)
      return

    $scope.$watchGroup ['apCtrl.form.tipo_id', 'apCtrl.form.assunto_id', 'apCtrl.form.movimentacao.destino_orgao_id'], (newValues) =>
      tipoId   = newValues[0]
      assuntoId = newValues[1]
      orgaoId   = newValues[2]

      if tipoId? and assuntoId? and orgaoId?
        assuntoId = if angular.isObject(assuntoId) and assuntoId.id? then assuntoId.id else assuntoId
        orgaoId = if angular.isObject(orgaoId) and orgaoId.id? then orgaoId.id else orgaoId
        $http.get '/formularios_editaveis/por_tipo_assunto',
          params:
            tipo_id: tipoId
            assunto_id: assuntoId
            orgao_id: orgaoId
        .then (response) =>
          $scope.apCtrl.formularios = response.data
          $('.select-orgao').trigger('change.select2')
      else
        $scope.apCtrl.formularios = []
        $('.select-orgao').trigger('change.select2')

    # WATCH FORMULARIO PERSONALIZADO (carrega definição quando tipo+assunto+orgao definidos)
    $scope.$watchGroup ['apCtrl.form.tipo_id', 'apCtrl.form.assunto_id', 'apCtrl.form.movimentacao.destino_orgao_id'], (newValues) =>
      tipoId    = newValues[0]
      assuntoId = newValues[1]
      orgaoId   = newValues[2]

      if tipoId? and assuntoId? and orgaoId?
        tipoId    = if angular.isObject(tipoId) and tipoId.id? then tipoId.id else tipoId
        assuntoId = if angular.isObject(assuntoId) and assuntoId.id? then assuntoId.id else assuntoId
        orgaoId   = if angular.isObject(orgaoId) and orgaoId.id? then orgaoId.id else orgaoId
        $http.get('/formularios_personalizados/abertura_regras_formularios.json', {params: {tipo_id: tipoId, assunto_id: assuntoId, orgao_id: orgaoId}, cache: true}).then ((result) ->
          if result.status == 200 && result.data && result.data.fields && result.data.fields.length > 0
            vm.formularioPersonalizado = result.data
            vm.camposPersonalizados    = valoresFormularioPersonalizadoSalvos(result.data.id)
            $timeout((-> initLongTextEditors()), 0)
          else
            vm.formularioPersonalizado = null
            vm.camposPersonalizados    = {}
          vm.formularioPersonalizadoErros = []
        ), (error) ->
          vm.formularioPersonalizado = null
          vm.camposPersonalizados    = {}
      else
        vm.formularioPersonalizado = null
        vm.camposPersonalizados    = {}

    # INIT SETUP
    init = () =>
      watchCorpo()
      removeShowOverlayPassos()
      carregarProtocolos()

      tipoId = angular.element('[data-tipo-id]').data('tipo-id')
      assuntoId = angular.element('[data-assunto-id]').data('assunto-id')
      orgaoId = angular.element('[data-orgao-id]').data('orgao-id')

      if tipoId? and assuntoId? and orgaoId
        vm.tipoId = tipoId.toString() if tipoId?
        vm.assuntoId = assuntoId.toString() if assuntoId?
        vm.orgaoId = orgaoId.toString() if orgaoId?
        
        $(window).on 'load', ->
          vm.form.tipo_id = vm.tipoId if vm.tipoId?
          vm.form.assunto_id = vm.assuntoId if vm.assuntoId?
          $('.select-tipo')
            .val(String(vm.tipoId))
            .trigger('change.select2')
          $('.select-assunto')
            .val(String(vm.assuntoId))
            .trigger('change.select2')

      # --- CUSTOM AUTOCOMPLETE (fallback robusto, independente do jQuery UI) ---
      setupCustomAutocomplete = ($input) ->
        return unless $input and $input.length

        modalSelector = '#modal-localizar-processo-assunto'
        $modal = $(modalSelector)
        refs = ->
          $m = $(modalSelector)
          {
            modal: $m
            result_tipo_processo: $m.find("dd#localizar-processo-result")
            result_assunto_processo: $m.find("dd#localizar-assunto-result")
            btn_usar_dados: $m.find(".modal-footer button")
            $input: $m.find('input#processo-assunto')
          }

        # cleanup caso já exista
        existing = $input.data('custom-autocomplete')
        if existing
          existing.destroy()

        # cria dropdown
        $dropdown = $('<ul class="simple-autocomplete-list" role="listbox" aria-label="Sugestões" />')
        $dropdown.css
          position: 'absolute'
          zIndex: 2050
          listStyle: 'none'
          margin: 0
          padding: 0
          background: '#fff'
          border: '1px solid #ccc'
          maxHeight: '260px'
          overflowY: 'auto'
          display: 'none'
          minWidth: $input.outerWidth()

        # append dentro do modal para z-index correto
        $modal.append($dropdown)

        activeIndex = -1
        items = []
        debounceTimer = null

        positionDropdown = ->
          offset = $input.offset()
          # posiciona em relação ao modal (usa offset real)
          $dropdown.css
            top: offset.top + $input.outerHeight()
            left: offset.left
            minWidth: $input.outerWidth()
            display: if items.length then 'block' else 'none'

        renderItems = (list) ->
          $dropdown.empty()
          items = list || []
          activeIndex = -1
          if not items.length
            $dropdown.hide()
            return
          for idx in [0...items.length]
            it = items[idx]
            $li = $('<li tabindex="-1" role="option" style="padding:6px 8px; cursor:pointer; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;"></li>')
            $li.text(it.tipo_processo_nome + ' - ' + it.assunto_processo_nome)
            $li.data('dados', it)
            $li.attr('data-index', idx)
            $dropdown.append($li)
          positionDropdown()

        fetchAndRender = (term) ->
          if not term or term.length < 2
            renderItems([])
            return
          $.ajax
            url: "/search_assunto_with_processo"
            data:
              maxRows: 10
              termo: term
            dataType: 'json'
            success: (retorno) ->
              # normaliza retorno para array
              arr = []
              try
                if Array.isArray(retorno)
                  arr = retorno
                else if retorno? and Array.isArray(retorno.data)
                  arr = retorno.data
              catch e
                arr = []
              renderItems(arr)
            error: (xhr, status, err) ->
              console.warn 'autocomplete ajax error', status, err
              renderItems([])

        setActive = (index) ->
          $dropdown.children().removeClass('active').css('background', '')
          if index >= 0 and index < $dropdown.children().length
            $el = $dropdown.children().eq(index)
            $el.addClass('active').css('background', '#f0f0f0')
            activeIndex = index
            # scroll to view
            top = $el.position().top
            h = $dropdown.height()
            if top + $el.outerHeight(true) > h
              $dropdown.scrollTop($dropdown.scrollTop() + (top + $el.outerHeight(true) - h))
            if top < 0
              $dropdown.scrollTop($dropdown.scrollTop() + top)
          else
            activeIndex = -1

        chooseIndex = (index) ->
          if index < 0 or index >= items.length then return
          data = items[index]
          if not data then return
          # atualiza UI
          r = refs()
          r.result_tipo_processo.html data.tipo_processo_nome
          r.result_assunto_processo.html data.assunto_processo_nome
          vm.buscaAssuntos = data
          r.btn_usar_dados.attr('disabled', false)
          # guarda dados global (opcional)
          vm.modalSelectedDados = data
          # limpa input e esconde dropdown
          $input.val('')
          $dropdown.hide()

        $("#definirTipoAssunto").on 'click', (e) ->
          vm.form.tipo_id = vm.buscaAssuntos.tipo_processo_id.toString()
          $('.select-tipo')
            .val(String(vm.form.tipo_id))
            .trigger('change.select2')
          setAssuntos(vm.form.tipo_id)
          $('#modal-localizar-processo-assunto').modal('hide')

        # events on dropdown
        $dropdown.on 'click', 'li', (e) ->
          $li = $(e.currentTarget)
          idx = parseInt($li.attr('data-index'))
          chooseIndex(idx)

        $dropdown.on 'mouseenter', 'li', (e) ->
          $li = $(e.currentTarget)
          idx = parseInt($li.attr('data-index'))
          setActive(idx)

        # keyboard on input
        $input.on 'keydown.custom-autocomplete', (e) ->
          key = e.key or e.which
          if key is 'ArrowDown' or key is 40
            e.preventDefault()
            next = activeIndex + 1
            if next >= $dropdown.children().length then next = 0
            setActive(next)
          else if key is 'ArrowUp' or key is 38
            e.preventDefault()
            prev = activeIndex - 1
            if prev < 0 then prev = $dropdown.children().length - 1
            setActive(prev)
          else if key is 'Enter' or key is 13
            if activeIndex >= 0
              e.preventDefault()
              chooseIndex(activeIndex)
          else if key is 'Escape' or key is 27
            $dropdown.hide()

        # input listener (debounced)
        $input.on 'input.custom-autocomplete', ->
          val = $input.val()
          window.clearTimeout(debounceTimer) if debounceTimer
          debounceTimer = window.setTimeout (-> fetchAndRender(val) ), 220

        # reposition on scroll/resize
        $(window).on 'resize.custom-autocomplete scroll.custom-autocomplete', ->
          if $dropdown.is(':visible') then positionDropdown()

        # hide on outside click
        setOutsideHandler = ->
          $(document).on 'click.custom-autocomplete', (e) ->
            if $(e.target).closest($input).length is 0 and $(e.target).closest($dropdown).length is 0
              $dropdown.hide()

        setOutsideHandler()

        destroy = ->
          $dropdown.remove()
          $input.off('.custom-autocomplete')
          $(window).off('.custom-autocomplete')
          $(document).off('.custom-autocomplete')
          $input.removeData('custom-autocomplete')
          if debounceTimer then window.clearTimeout(debounceTimer)

        # store reference to allow destroy later
        $input.data('custom-autocomplete', { destroy: destroy })

        # cleanup when modal hides
        $modal.on 'hidden.bs.modal.custom-autocomplete', ->
          destroy()
          # limpa displays
          r = refs()
          r.result_tipo_processo.html '-'
          r.result_assunto_processo.html '-'
          $input.val('')
          vm.buscaAssuntos = null
          r.btn_usar_dados.attr('disabled', true)

        # done: return the dropdown object
        return $dropdown
      # --- end setupCustomAutocomplete ---
      $(document).on 'shown.bs.modal', '#modal-localizar-processo-assunto', ->
        $input = $('#modal-localizar-processo-assunto input#processo-assunto')
        setupCustomAutocomplete($input)
      return

    # METHODS PRIVATE
    setAssuntos = (tipo_id) ->
      if tipo_id? && tipo_id != ""
        vm.loadingAssuntos = true
        vm.assuntos        = [{nome: 'Carregando...'}]
        $http.get(Routes.assuntos_processos_path(tipo_id), {cache: true}).then ((result) ->
          if(result.status == 200)
            vm.assuntos = result.data
            vm.form.assunto_id = {id: vm.form.assunto_id} if vm.form?.assunto_id
            if vm.buscaAssuntos?.assunto_processo_id
              vm.form.assunto_id = vm.assuntos.find (a) ->
                  a.id.toString() is vm.buscaAssuntos.assunto_processo_id.toString()

              $timeout ->
                $('.select-assunto').trigger('change.select2')
          else
            notification.warning({
              message:     'Atenção',
              description: 'Não foi possível processar o pedido.',
              duration:    10,
              placement:   'bottomRight'
            })
          vm.loadingAssuntos = false
        ), (error) ->
          vm.loadingAssuntos = false
          notification.error({
            message:     'Erro',
            description: error.data.message,
            duration:    10,
            placement:   'bottomRight'
          })
      return

    blockedOrgaosByAssuntoId = (assunto_id) ->
      if assunto_id? && assunto_id != ""
        $http.get(Routes.orgaos_blocked_by_assunto_tipo_assunto_processo_path(assunto_id), {cache: true}).then ((result) ->
          if(result.status == 200)
            if vm.orgaos.length != vm.allOrgaos.length
              vm.orgaos = vm.allOrgaos
            blocked_ids = result.data
            vm.orgaos = vm.orgaos.filter (orgao) -> (!blocked_ids.includes(parseInt(orgao.id)))
            if vm.orgaoId?
              orgao = vm.orgaos.find (o) -> String(o.id) == vm.orgaoId
              vm.form.movimentacao.destino_orgao_id = orgao if orgao?
              vm.orgaoId = null
          else
            notification.warning({
              message:     'Atenção',
              description: 'Não foi possível processar o pedido.',
              duration:    10,
              placement:   'bottomRight'
            })
          vm.loadingAssuntos = false
        ), (error) ->
          vm.loadingAssuntos = false
          console.log(error)
          notification.error({
            message:     'Erro',
            description: error.data.message || 'Não foi possível processar o pedido.',
            duration:    10,
            placement:   'bottomRight'
          })

      return

    valoresFormularioPersonalizadoSalvos = (formularioId) ->
      valores = vm.formularioPersonalizadoValores || {}
      return {} unless valores.formulario_personalizado_id? && valores.campos?
      return {} unless String(valores.formulario_personalizado_id) == String(formularioId)

      angular.copy(valores.campos || {})

    watchCorpo = ->
      $('.summernote').on
        'summernote.init': () ->
          isEmpty = $(this).summernote('isEmpty')
          $scope.$apply -> corpoPresent = !isEmpty
          return
        'summernote.change': (_we, _contents, _$editable) ->
          isEmpty = $(this).summernote('isEmpty')
          $scope.$apply -> corpoPresent = !isEmpty
          return

      return

    initLongTextEditors = ->
      return unless vm.formularioPersonalizado?.fields?.length > 0

      $timeout((->
        $('.fp-long-text').each ->
          $el = $(this)
          return if $el.data('fp-long-text-initialized')

          fieldKey = $el.data('field-key')
          return unless fieldKey?

          initialValue = vm.camposPersonalizados[fieldKey] || ''

          $el.summernote({
            disableDragAndDrop: true,
            height: 150,
            lang: 'pt-BR',
            toolbar: [
              ['font', ['bold', 'italic', 'underline', 'clear']],
              ['style', ['forecolor', 'backcolor']],
              ['para', ['ul', 'ol', 'paragraph']],
            ],
            callbacks:
              onInit: ->
                unless initialValue.toString().trim() == ''
                  $el.summernote('code', initialValue)
              onChange: (contents) ->
                $scope.$applyAsync ->
                  vm.camposPersonalizados[fieldKey] = contents
          })

          $el.data('fp-long-text-initialized', true)
      ), 0)
      return

    removeShowOverlayPassos = ->
      $timeout (-> vm.showOverlayPassos = false), 1000
      return

    checarDocumentosWorkflow = (params) ->
      vm.abrirWorkFlow = true
      vm.uploadProps   = angular.copy(vm.baseUploadProps)
      resetWorkflowSetorInativo()
      return $http.get(Routes.abertura_regras_documentos_processos_workflows_path(params)).then ((result) ->
        if(result.status == 200)
          if result.data? and result.data.workflow_setor_inativo
            bloquearWorkflowSetorInativo(result.data)
          else if result.data? and result.data.setor_id? and result.data.setor?
            vm.setarSetor = {nome: result.data.setor, setor_id: result.data.setor_id}
          else
            vm.setarSetor = {}
          hasCheckList = result.data? and !result.data.workflow_setor_inativo and 'check_list' of result.data
          vm.uploadProps = Object.assign vm.uploadProps,
            workflowDocumentos: if hasCheckList then result.data else {}
          if Object.keys(vm.uploadProps.workflowDocumentos).length > 0
            vm.possuiFluxo = true
          else
            vm.possuiFluxo = false
          $timeout ((->
            ReactRailsUJS.unmountComponents("#upload-documentos")
            ReactRailsUJS.mountComponents("#upload-documentos")
          )), 200

        else
          notification.warning({
            message:     'Atenção',
            description: 'Não foi possível processar o pedido.',
            duration:    10,
            placement:   'bottomRight'
          })
        vm.loadingAssuntos = false
      ), (error) ->
        vm.loadingAssuntos = false
        notification.error({
          message:     'Erro',
          description: error.data.message,
          duration:    10,
          placement:   'bottomRight'
        })

    carregarProtocolos = ->
      if vm.workflowSetorInativo
        vm.protocolos = []
        vm.form.movimentacao.destino_setor_id = null
        vm.recarregarSelectSetor()
        return

      orgao = vm.form.movimentacao.destino_orgao_id
      if orgao? and orgao.protocolos?
        if vm.possuiFluxo and 'setor' of vm.uploadProps.workflowDocumentos and vm.uploadProps.workflowDocumentos.setor?
          vm.protocolos = [{id: vm.uploadProps.workflowDocumentos.setor_id, nome: vm.uploadProps.workflowDocumentos.setor}]
        else if vm.setarSetor? and vm.setarSetor.nome and vm.setarSetor.setor_id 
          vm.protocolos = [{id: vm.setarSetor.setor_id, nome: vm.setarSetor.nome}]
        else
          vm.protocolos = orgao.protocolos
        if vm.protocolos.length == 1
          vm.form.movimentacao.destino_setor_id = vm.protocolos[0].id
        
        vm.recarregarSelectSetor()
      else
        vm.protocolos = []

    resetWorkflowSetorInativo = ->
      vm.workflowSetorInativo = false
      return

    bloquearWorkflowSetorInativo = (data) ->
      vm.workflowSetorInativo = true
      vm.abrirWorkFlow = false
      vm.setarSetor = {}
      vm.possuiFluxo = false
      vm.protocolos = []
      vm.form.movimentacao.destino_setor_id = null

      suporte = data.suporte || {}
      emails = suporte.emails || ['atendimento@sepog.fortaleza.ce.gov.br']
      telefones = suporte.telefones || ['(85) 3512-6777']
      whatsapp = suporte.whatsapp || ['(85) 9197-6143 (apenas WhatsApp)']
      contatos = []
      contatos.push("<strong>E-mail:</strong> #{emails.join(', ')}") if emails.length > 0
      contatos.push("<strong>Telefone:</strong> #{telefones.join(', ')}") if telefones.length > 0
      contatos.push("<strong>WhatsApp:</strong> #{whatsapp.join(', ')}") if whatsapp.length > 0

      if window.Swal?
        Swal.fire
          icon: 'warning'
          title: 'Setor de envio está desativado'
          html: """
            <p>#{data.message || 'Por favor, entre em contato com o administrador do sistema.'}</p>
            <hr>
            <p class="mb-1"><strong>Contato do suporte:</strong></p>
            <p class="mb-0">#{contatos.join('<br>')}</p>
          """
          confirmButtonText: 'Fechar'
          confirmButtonColor: '#199b91'
      else
        alert(data.message || 'Não existe um setor ativo cadastrado para este fluxo. Por favor, entre em contato com o administrador do sistema.')

      return

    # METHODS VIEW MODEL
    vm.temFormularioPersonalizado = ->
      !!(vm.formularioPersonalizado && vm.formularioPersonalizado.fields && vm.formularioPersonalizado.fields.length > 0)

    vm.changeAbrirWorkFlow = (bool = true) ->
      vm.abrirWorkFlow = bool
      return

    vm.recarregarSelectSetor = ->
      if vm.destino_setor_carregado != null
        vm.form.movimentacao.destino_setor_id = vm.destino_setor_carregado.toString()
        vm.destino_setor_carregado = null

      setTimeout ->
        $el = $('#select-destino-setor')

        # Força reinicialização do select2
        if $el.hasClass('select2-hidden-accessible')
          $el.select2('destroy')

        $el.select2()
        destinoSetorId = vm.form.movimentacao.destino_setor_id
        $el.val(if destinoSetorId? then destinoSetorId.toString() else null).trigger('change')
      , 0

    vm.abrirModalLocalizarAssunto = ->
      $('#modal-localizar-processo-assunto').modal('show')
    vm.fecharModalLocalizarAssunto = ->
      $('#modal-localizar-processo-assunto').modal('hide')

    vm.changeUploadDocumentos = (bool = true) ->
      vm.uploadDocumentos = bool
      return

    vm.canNotShowOrgao = ->
      return !vm.showOverlayPassos && (!vm.form.tipo_id || !vm.form.assunto_id)

    vm.canNotShowDescricao = ->
      return !vm.showOverlayPassos && (!vm.form.tipo_id || !vm.form.assunto_id || !vm.form.movimentacao.destino_orgao_id)

    vm.canNotShowUpload = ->
      return !vm.showOverlayPassos && (!vm.form.tipo_id || !vm.form.assunto_id || !vm.form.movimentacao.destino_orgao_id || !corpoPresent)

    vm.canSubmit = ->
      campos_obrigatorios =
        vm.form.tipo_id && vm.form.assunto_id && vm.form.movimentacao.destino_orgao_id && vm.form.movimentacao.destino_setor_id && corpoPresent && vm.abrirWorkFlow && !vm.uploadDocumentos && !vm.workflowSetorInativo

      return campos_obrigatorios && vm.formularioPersonalizadoCompleto()

    vm.formularioPersonalizadoCompleto = ->
      return true unless vm.formularioPersonalizado && vm.formularioPersonalizado.fields && vm.formularioPersonalizado.fields.length > 0
      faltando = []
      for f in vm.formularioPersonalizado.fields
        if (f.required == true || f.required == 'true')
          val = vm.camposPersonalizados[f.key]
          if f.type == 'checkbox'
            faltando.push(f.label) if val != true && val != 'true'
          else if f.type == 'long-text'
            faltando.push(f.label) if htmlStringBlank(val)
          else
            faltando.push(f.label) if val == undefined || val == null || (typeof val == 'string' && val.trim() == '')
      vm.formularioPersonalizadoErros = faltando
      return faltando.length == 0

    vm.camposPersonalizadosJson = ->
      return JSON.stringify(vm.camposPersonalizados || {})

    vm.submitForm = (event) ->
      event.preventDefault()
      unless vm.formularioPersonalizadoCompleto()
        return
      modal = $('#modal-processo-abertura')
      modal.modal('show')
      $('.modal-backdrop').appendTo(modal.parent())

      return

    htmlStringBlank = (value) ->
      return true if value == undefined || value == null
      text = String(value)
      text = text.replace(/<[^>]*>/g, '')
      text = text.replace(/&nbsp;/gi, ' ')
      text.trim() == ''

    vm.message = (t) ->
      alert(t)

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'AberturaProcessoController', AberturaProcessoController

  # ANGULAR INJECT DEPENDENCIES
  AberturaProcessoController.$inject = ['$http', '$scope', '$timeout', '$window']

  # END BLOCK SCRIPT
  return
